import React from 'react';
 
const home = () => {
    return (
        <div className="home">
            <img src={require('../img/IMG-20191012-WA0001.jpg')} alt={""} />
            <footer>
                <small id="licence">
                    <a href="http://www.antonioteixeira.fr" rel="noopener noreferrer" target="_blank"><img src={require('../img/logo.png')} alt={""} />© Copyright 2020 - Le site a été réalisé par Antonio Teixeira.</a>
                </small>	
            </footer>
        </div>
        
    );
}
 
export default home;